import React, { CSSProperties, HTMLAttributes } from "react";
import styled from "styled-components";

type Props = HTMLAttributes<HTMLDivElement> & {
  height?: CSSProperties["height"];
  expandOnHover?: boolean;
};

const StyledInner = styled.div`
  /* padding: 0.5rem; */
`;

const StyledOuter = styled.div<Props>`
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;

  ${(props) =>
    props.height == null
      ? `white-space: nowrap;`
      : `max-height: ${props.height};`}

  ${(props) =>
    props.expandOnHover === true &&
    `
      &:hover {
        overflow: visible;

        ${StyledInner} {
          position: relative;
          box-shadow: 0 0 4px 0 black;
          background-color: white;
        }
      }
    `}
`;

const Truncate = ({ children, ...props }: Props) => (
  <StyledOuter {...props}>
    <StyledInner>{children}</StyledInner>
  </StyledOuter>
);

export default Truncate;
